import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/vercel/path0/app/layouts/account.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/app/layouts/default.vue").then(m => m.default || m))
}